import { render, staticRenderFns } from "./EmployeesEdit.vue?vue&type=template&id=1410b9d6&"
import script from "./EmployeesEdit.vue?vue&type=script&lang=ts&"
export * from "./EmployeesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VCard,VContent})
